import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import axios from 'axios';

//React export function used to display the consignee address block
export default function DeliveryAddress() {
    //Setting the states 
    const [values, setValues] = useState([]);
    const [deliveryAddressID, setDeliveryAddressID] = useState(0);
    const [CODDeliveryAddressName, setCODDeliveryAddressName] = useState("");

    if (CODDeliveryAddressName === "") {
        if ('CODDeliveryAddressName' in sessionStorage) {
            setCODDeliveryAddressName(sessionStorage.getItem('CODDeliveryAddressName'))
        }
    }

    //On change handle the get address request
    const handleDeliveryAddress = () => {
        if (CODDeliveryAddressName !== "") {
            setValues([]);
            var value = 'a';
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetAddress`, { params: { searchField: value} })
                .then((res) => {
                    setValues(res.data);
                })
                .catch((e) => {
                    console.log('DeliveryAddress error occurred with the API process');
                });
        }
    };

    const handleDeliveryAddressID = (newValue) => {
        if (newValue !== null) {
            setDeliveryAddressID(newValue.id);
            sessionStorage.removeItem('CODeliveryAddressID')
            sessionStorage.setItem('CODeliveryAddressID', newValue.id);
            setCODDeliveryAddressName(newValue.label);
        }
    };

    //Render the dropdowns onto the screen
    return (
        <React.Fragment>
            <GridContainer direction={'row'}>
                <GridItem xs={12}>
                    <input type="hidden" name="deliveryAddressIDCO" id="deliveryAddressIDCO" value={deliveryAddressID} />
                    <Autocomplete
                        size="small"
                        disablePortal
                        id="Consignee"
                        options={values}
                        onInputChange={(event) => handleDeliveryAddress()}
                        onChange={(event, newValue) => {
                            handleDeliveryAddressID(newValue)
                        }}
                        value={CODDeliveryAddressName}
                        sx={{ marginTop: 1, width: '100%' }}
                        renderInput={(params) => <TextField size="small" {...params} id="Consignee" name="Consignee" label="Consignee" required />}
                    />
                </GridItem>
            </GridContainer>
        </React.Fragment>
    );
}
